module.exports = __webpack_public_path__ + "static/fonts/iconfont.68fb7c1.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/iconfont.eot?t=1559020008880
// module id = agbS
// module chunks = 96